(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dug-strap-model-guard"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dug-strap-model-picker')) {
    customElements.define('dug-strap-model-picker', class extends HTMLElement {
      connectedCallback() {
        this.onChange = event => {
          if (event.target.matches('[data-dug-model-choice]')) {
            const value = event.target.value;
            const select = this.querySelector('select[data-dug-model-input]');
            if (select) {
              select.value = value;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              const radio = Array.from(this.querySelectorAll('input[data-dug-model-input]')).find(input => input.value === value);
              if (radio) {
                const alreadyChecked = radio.checked;
                radio.click();
                if (alreadyChecked) radio.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          }
          this.sync();
        };
        this.onSubmit = event => {
          const choice = this.querySelector('[data-dug-model-choice]');
          if (this.dataset.requireChoice === 'true' && (!choice?.value || choice.value !== this.modelValue())) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.querySelector('[data-dug-model-choice]')?.focus();
          }
        };
        this.addEventListener('change', this.onChange);
        this.readyFrame = requestAnimationFrame(() => {
          this.scope = this.closest('product-single, quick-shop, product-card-quick-shop, .quick-shop') || this.parentElement;
          this.observer = new MutationObserver(() => this.sync());
          this.observer.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
          this.sync();
        });
      }
      modelValue() {
        const field = this.querySelector('select[data-dug-model-input], input[data-dug-model-input]:checked');
        return field ? field.value : '';
      }
      sync() {
        const form = document.getElementById(this.dataset.productForm);
        if (form && this.form !== form) {
          this.form?.removeEventListener('submit', this.onSubmit, true);
          this.form = form;
          form.addEventListener('submit', this.onSubmit, true);
        }
        const model = this.modelValue();
        const choice = this.querySelector('[data-dug-model-choice]');
        const pending = this.dataset.requireChoice === 'true' && (!choice?.value || choice.value !== model);
        this.querySelector('[data-dug-model-help]')?.toggleAttribute('hidden', !pending);
        if (form) {
          form.toggleAttribute('data-dug-model-pending', pending);
          if (!pending) form.querySelectorAll('[data-dug-model-pending]').forEach(node => node.removeAttribute('data-dug-model-pending'));
          if (pending) {
            form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(button => {
              if (!button.disabled) button.disabled = true;
            });
          }
          form.querySelectorAll('.shopify-payment-button, shopify-accelerated-checkout').forEach(payment => {
            if (pending) {
              payment.dataset.dugModelLocked = 'true';
              payment.inert = true;
            } else if (payment.dataset.dugModelLocked) {
              delete payment.dataset.dugModelLocked;
              payment.inert = false;
            }
          });
        }
        (this.scope || this.parentElement).querySelectorAll('[data-dug-strap-notice]').forEach(notice => {
          if (notice.dataset.dugStrapNotice !== this.dataset.productForm) return;
          notice.querySelector('[data-dug-model-help]')?.toggleAttribute('hidden', !pending);
          notice.querySelectorAll('[data-dug-model-notice]').forEach(line => {
            line.hidden = pending || !model.includes(line.dataset.dugModelNotice);
          });
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.readyFrame);
        this.observer?.disconnect();
        this.removeEventListener('change', this.onChange);
        this.form?.removeEventListener('submit', this.onSubmit, true);
        this.form = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
